<div class="okta-container text-center">
  @if (!hasError) {
    <div class="wrapper">
      <mat-icon class="spin loading-icon">autorenew</mat-icon>
      <br><br>
      <h1 class="lead">Signing in ....</h1>
    </div>
  }
  @if (hasError) {
    <div class="wrapper retry">
      <div class="alert" role="alert">
        {{errorMsg}}
      </div>
      <div class="contact-message">
        {{contactMessage}}
      </div>
      @if (isRetryButton) {
        <div >
          <br>
            <button  color="primary" mat-raised-button type="button" (click)="retry()">Try again</button>
          </div>
        }
      </div>
    }
  </div>
